import identity from '@Ravnur-Inc/nanoutils/identity';
import some from '@Ravnur-Inc/nanoutils/some';

import isAndroid from './isAndroid';
import isiOS from './isiOS';

export default some(identity, [isAndroid, isiOS]);
